import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';

export interface StorageCardProps {
  icon: ReactNode;
  title: string;
  storageUsed: string;
  onViewMore?: () => void;
}

export const StorageCard: FC<StorageCardProps> = ({
  icon,
  title,
  storageUsed,
  onViewMore
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 text-[#8D8D8D]">
      <div className="w-6 h-6 flex-shrink-0">{icon}</div>
      <div className="">
        <h3 className="text-xl font-semibold text-gray-1">{title}</h3>
      </div>
      <div className="flex-1">
        <p className="text-xs font-medium text-gray-1">{storageUsed}</p>
      </div>
      {onViewMore && (
        <Button
          btnStyle="link"
          onClick={onViewMore}
          className="text-sm font-bold text-[#49712B] hover:underline">
          {t('viewMore')}
        </Button>
      )}
    </div>
  );
};
